import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SortDirection } from 'src/@smartmanufacturing/common/enum';
import { DataMapper } from 'src/app/user-management/shared/models/data-mapper';
import { MultiplePlantRequest, UsersRequestsSent, MultiplePlantRequestDetail } from 'src/app/user-management/user-management-setup/models/multiple-plant-request';
import { BaseApi } from 'src/backend/api/base-api';

@Injectable({
    providedIn: 'root'
})
export class MultiplePlantRequestService {

    constructor(private baseApi: BaseApi, private http: HttpClient) { }

    getAllMultiplePlantRequests(data: any): Observable<DataMapper<MultiplePlantRequest>> {
        let params = '';
        if (data?.pageIndex) {
            params += 'offset=' + data?.pageIndex.toString();
        }
        if (data?.pageSize) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'limit=' + data?.pageSize.toString();
        }
        if (data?.status) {
            if (params.length > 0) {
                params += '&';
            }
            params += `status=` + data?.status;
        }
        if (data?.sortDirection !== SortDirection.None) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'sortDirection=' + data?.sortDirection;
        }
        if (data?.sortField) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'sortField=' + data?.sortField;
        }
        if (data?.searchValue) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'phrase=' + data?.searchValue;
        }
        return this.http.get<DataMapper<MultiplePlantRequest>>(this.baseApi.encodeURL(Constants.API_MULTIPLE_PLANT_REQUESTS + '?' + params))
    }

    getAllUserRequestsSent(data: any): Observable<DataMapper<UsersRequestsSent>> {
        let params = '';
        if (data?.pageIndex) {
            params += 'offset=' + data?.pageIndex.toString();
        }
        if (data?.pageSize) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'limit=' + data?.pageSize.toString();
        }
        if (data?.status) {
            if (params.length > 0) {
                params += '&';
            }
            params += `status=` + data?.status;
        }
        if (data?.sortDirection !== SortDirection.None) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'sortDirection=' + data?.sortDirection;
        }
        if (data?.sortField) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'sortField=' + data?.sortField;
        }
        if (data?.searchValue) {
            if (params.length > 0) {
                params += '&';
            }
            params += 'phrase=' + data?.searchValue;
        }
        return this.http.get<DataMapper<UsersRequestsSent>>(this.baseApi.encodeURL(Constants.API_USERS_REQUESTS_SENT + '?' + params))
    }

    approveRequest(id: number): Observable<any> {
        return this.http.put<any>(this.baseApi.encodeURL(Constants.API_MULTIPLE_PLANT_REQUEST_APPROVE + '/' + id), {});
    }
    rejectRequest(id: number): Observable<any> {
        return this.http.put<any>(this.baseApi.encodeURL(Constants.API_MULTIPLE_PLANT_REQUEST_REJECT + '/' + id), {});
    }
    getRequestDetails(requestCode: string): Observable<MultiplePlantRequestDetail> {
        return this.http.get<MultiplePlantRequestDetail>(this.baseApi.encodeURL(Constants.API_MULTIPLE_PLANT_REQUEST_DETAILS + '/' + requestCode));
    }

}
